//App.js
import "./App.css";
import Navbar from "./components/sections/Navbar";
import AppRoutes from "./components/sections/AppRoutes";
import Footer from "./components/sections/Footer";

function App() {
  return (
    <>
      <Navbar />
      <AppRoutes />
      <Footer />
    </>
  );
}

export default App;
